import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=150ad8f6&scoped=true&"
import script from "./RadioView.vue?vue&type=script&lang=js&"
export * from "./RadioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ad8f6",
  null
  
)

export default component.exports